module.exports = __webpack_public_path__ + "img/like.278e64e8.png";